// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"landingMobile-module--wrapper--1LII1","glue":"landingMobile-module--glue--OpjyM"};